import { trackEvent as t } from '../track';
import {
  GroupsMetadataProps,
  GroupsActionMetadataProps,
  GroupMember,
  GroupGetStartedActionProps,
  GroupGetStartedNodeProps,
} from './propertyTypes';

interface GroupsMemberActionMetadataProps extends GroupsActionMetadataProps {
  '[Group] Member'?: GroupMember;
}

export const groups = {
  earlyAccess: {
    click: () => t('[Groups] [Early Access] Request'),
  },
  edit: {
    click: (props: GroupsMetadataProps) => t('[Groups] [Edit] Initiated', props),
    complete: (props: GroupsMetadataProps) => t('[Groups] [Edit] Complete', props),
  },
  create: {
    click: () => t('[Groups] [Create] Initiated'),
    hover: () => t('[Groups] [Create] Hover'),
    complete: (props: GroupsActionMetadataProps) => t('[Groups] [Create] Complete', props),
  },
  delete: {
    click: (props: GroupsActionMetadataProps) => t('[Groups] [Delete] Initiated', props),
    complete: (props: GroupsActionMetadataProps) => t('[Groups] [Delete] Complete', props),
  },
  document: {
    add: (props: GroupsActionMetadataProps) => t('[Groups] [Document] Add', props),
    remove: (props: GroupsActionMetadataProps) => t('[Groups] [Document] Remove', props),
  },
  members: {
    add: {
      click: (props: GroupsMemberActionMetadataProps) =>
        t('[Groups] [Members] [Add] Initiated', props),
      complete: (props: GroupsMemberActionMetadataProps) =>
        t('[Groups] [Members] [Add] Complete', props),
      search: (props: GroupsActionMetadataProps) => t('[Groups] [Members] [Add] Search', props),
      selectResult: (props: GroupsActionMetadataProps) =>
        t('[Groups] [Members] [Add] Select search result', props),
    },
    remove: {
      click: (props: GroupsMemberActionMetadataProps) =>
        t('[Groups] [Members] Remove initiated', props),
      complete: (props: GroupsMemberActionMetadataProps) =>
        t('[Groups] [Members] Remove complete', props),
    },
  },
  page: {
    viewGetStarted: (props: GroupsMetadataProps) => t('[Groups] [Page] View Get Started', props),
    viewFeed: (props: GroupsMetadataProps) => t('[Groups] [Page] View feed', props),
    viewPeople: (props: GroupsMetadataProps) => t('[Groups] [Page] View people', props),
    viewPinned: (props: GroupsMetadataProps) => t('[Groups] [Page] View pinned', props),
  },
  getStarted: {
    select: (props: GroupGetStartedNodeProps) => t('[Groups] [Get Started] Select Document', props),
    add: (props: GroupGetStartedActionProps) =>
      t('[Groups] [Get Started] Add Selected Documents', props),
    skip: (props: GroupsMetadataProps) => t('[Groups] [Get Started] Skip', props),
    complete: (props: GroupGetStartedActionProps) => t('[Groups] [Get Started] Complete', props),
  },
  sidebar: {
    collapse: (props: GroupsActionMetadataProps) => t('[Groups] [Sidebar] Collapse group', props),
    expand: (props: GroupsActionMetadataProps) => t('[Groups] [Sidebar] Expand group', props),
    select: (props: GroupsActionMetadataProps) => t('[Groups] [Sidebar] Select group', props),
    selectMember: (props: GroupsMemberActionMetadataProps) =>
      t('[Groups] [Sidebar] Select group member', props),
  },
};
